import { render, staticRenderFns } from "./WeekdaysInput.vue?vue&type=template&id=498fa396&scoped=true"
import script from "./WeekdaysInput.vue?vue&type=script&lang=ts"
export * from "./WeekdaysInput.vue?vue&type=script&lang=ts"
import style0 from "./WeekdaysInput.vue?vue&type=style&index=0&id=498fa396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498fa396",
  null
  
)

export default component.exports